import { create } from 'zustand';

type GlobalLoadingStore = {
  isShow: boolean;
  isCenter: boolean;
  showLoading: () => void;
  hideLoading: () => void;
  setLoadingCenter: (isCenter: boolean) => void;
};

const useGlobalLoadingStore = create<GlobalLoadingStore>((set) => ({
  isShow: false,
  isCenter: false,
  showLoading: () => set(() => ({ isShow: true })),
  hideLoading: () => set(() => ({ isShow: false })),
  setLoadingCenter: (isCenter: boolean) => set(() => ({ isCenter })),
}));

export const useGlobalLoading = () => {
  const isShow = useGlobalLoadingStore((state) => state.isShow);
  const isCenter = useGlobalLoadingStore((state) => state.isCenter);

  return {
    isShow,
    isCenter,
  };
};

export const useGlobalLoadingHandler = () => {
  const showLoading = useGlobalLoadingStore((state) => state.showLoading);
  const hideLoading = useGlobalLoadingStore((state) => state.hideLoading);
  const setLoadingCenter = useGlobalLoadingStore((state) => state.setLoadingCenter);

  return {
    showLoading,
    hideLoading,
    setLoadingCenter,
  };
};
